export const ROLES_LIST_URL: string = 'roles';
export const ROLES_ALL_LIST_URL: string = 'roles/all';
export const NEW_ROLE_URL: string = 'roles';
export const ROLE_URL: string = 'roles/{linkName}';
export const PUT_ROLE_PERMISSIONS_URL: string = 'roles/{linkName}/permissions';
